import React from 'react'
import Modal from './Modal'
import ModalBody from './ModalBody'
import styled from 'styled-components'
import { Alert, Success } from 'core-system/Icons/Misc'
import palette from 'core-system/Themes/palette'
import Text from 'core-system/Text/Text'
import PrimaryButton from 'core-system/Button/PrimaryButton'

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  margin-bottom: 1rem;
`

const ModalBodyContainer = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 1.5rem;
  padding-top: 1.5rem;
  max-width: 30rem;
  text-align: center;
`

interface AlertSuccessModalProps {
  open: boolean
  onClose: (e: React.MouseEvent<any>) => void
  type: 'alert' | 'success'
  headerText: string
  message?: string
  buttonText?: string
  onButtonClick?: () => void
}

// TODO: Add option for multiple buttons (e.g. 'Sync Another in Finch Worksite Select Modal')
const AlertSuccessModal = React.memo((props: AlertSuccessModalProps) => {
  const {
    open,
    onClose,
    type,
    headerText,
    message,
    buttonText = 'OK',
    onButtonClick = onClose,
  } = props

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBodyContainer>
        <ModalHeader>
          {type === 'alert' ? (
            <Alert
              color={palette.error.red700}
              height={30}
              width={30}
              style={{ marginBottom: '1rem' }}
            />
          ) : (
            <Success
              color={palette.success.green500}
              height={30}
              width={30}
              style={{ marginBottom: '1rem' }}
            />
          )}
          <Text variant='h3'>{headerText}</Text>
        </ModalHeader>
        {message && message !== '' ? (
          <Text variant='action2'>{message}</Text>
        ) : null}
        <PrimaryButton onClick={onButtonClick} style={{ marginTop: '1rem' }}>
          {buttonText}
        </PrimaryButton>
      </ModalBodyContainer>
    </Modal>
  )
})

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  AlertSuccessModal.displayName = 'AlertSuccessModal'
}

export default AlertSuccessModal
